import { subscribe } from './reducers/subscription';
import { request as update } from './reducers/update';
import { request as addSelection } from './reducers/add-selection';
import { request as settle } from './reducers/settle';
import { request as addRule4 } from './reducers/add-rule4';
import { request as updateRule4 } from './reducers/update-rule4';
import { request as addDividend } from './reducers/add-dividend';
import { request as updateDividend } from './reducers/update-dividend';
import { request as addAllSelections } from './reducers/add-all-selections';
import { request as getMarketsByEventId } from './reducers/get-markets-by-eventid';

// eslint-disable-next-line import/no-default-export
export default {
    MARKETS_UPDATE_REQUEST: update,
    MARKETS_ADD_SELECTION_REQUEST: addSelection,
    MARKETS_ADD_RULE4_REQUEST: addRule4,
    MARKETS_UPDATE_RULE4_REQUEST: updateRule4,
    MARKETS_ADD_DIVIDEND_REQUEST: addDividend,
    MARKETS_UPDATE_DIVIDEND_REQUEST: updateDividend,
    MARKETS_SETTLE_REQUEST: settle,
    MARKETS_ADD_ALL_SELECTIONS_REQUEST: addAllSelections,

    MARKETS_SUBSCRIBE: subscribe,
    GET_MARKETS_BY_EVENTID_REQUEST: getMarketsByEventId,
};
